import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    window.addEventListener("load", () => {
      if (!sessionStorage.getItem("sessionActive")) {
        localStorage.clear();
        sessionStorage.setItem("sessionActive", "true");
      }
    });
    
    const code = route.queryParams['code'];

    if (code) {
      return new Promise(resolve => {
        this.authService.getTokens(code).subscribe({
          next: (response: any) => {       
            localStorage.setItem('access_token', response.access_token);
            localStorage.setItem('id_token', response.id_token);
            if (response.refresh_token) {
              localStorage.setItem('refresh_token', response.refresh_token);
            }
            sessionStorage.setItem('token_exchanged', 'true');
            resolve(true);
          },
          error: (error) => {
            console.error('Error al obtener tokens:', error);
            this.router.navigate(['/error-404']);
            resolve(false);
          }
        });
      });
    }else{
      const token = localStorage.getItem('access_token');
      if (token) {
      return true;
    }
    }
    this.router.navigate(['/error-404']);
    return false;
  }
}